/**
 * Аялал дуусгах — цуглуулагчийн ЗАРЛАСАН нийлбэрийг бүртгэгдсэн гутлын
 * мөрүүдтэй тулгана.
 *
 * ЯАГААД ХОЁР ТОО ВЭ
 *  Гутал бүрийн үнэ Оросод, бүртгэх мөчид оруулагдана. Аялал дуусахад
 *  цуглуулагч нийлүүлэгчид өгсөн НИЙЛБЭРЭЭ өөрөө хэлнэ. Хоёр нь
 *  тохирвол бүртгэл бүтэн; зөрвөл гутал дутуу бүртгэгдсэн (эсвэл дүн
 *  буруу шивэгдсэн) гэсэн үг. Энэ зөрүү нь тэр алдааг олох ЦОРЫН ГАНЦ
 *  дохио тул хоёр тоог хэзээ ч нэгтгэхгүй, нэгээр нь нөгөөг засахгүй.
 *
 * ⚠️ ₽ ба ₮ нь ТУСДАА бодит төлбөр — нэг нь нөгөөгийн хөрвүүлэг БИШ.
 *    Гутлын мөрүүд рублиэр үүсдэг тул тулгалт зөвхөн ₽ талд боломжтой;
 *    зарласан ₮ нь эсрэг талгүй төлбөрийн бүртгэл.
 */
import { money, ZERO } from './cost.js';
/**
 * Аялалын төлвийн монгол нэршил.
 *
 * ⚠️ Вэб ба гар утас ХУВААЛЦАНА. Утас нь `DRAFT`, `SYNCED` гэсэн
 *    enum-ээ шууд хэвлэдэг байсан — «UI бүх текст монголоор» дүрмийн
 *    зөрчил. Хоёр газар хоёр толь бичвэл нэг нь хоцордог.
 */
export const PURCHASE_STATUS_MN = {
    DRAFT: 'Ноорог',
    SYNCED: 'Sync хийгдсэн',
    COSTED: 'Өртөг тооцсон',
    RECEIVED: 'Хүлээн авсан',
};
function sum(groups, pick) {
    return groups.filter(pick).reduce((s, g) => s.plus(money(g.amount)), ZERO);
}
export function reconcileTrip(declared, groups) {
    const totalRub = sum(groups, (g) => g.currency === 'RUB');
    const creditRub = sum(groups, (g) => g.currency === 'RUB' && g.isCredit);
    return {
        items: { totalRub, creditRub },
        variance: {
            totalRub: money(declared.totalRub).minus(totalRub),
            creditRub: money(declared.creditRub).minus(creditRub),
        },
        credit: {
            count: groups.filter((g) => g.isCredit).reduce((n, g) => n + g.count, 0),
            amount: sum(groups, (g) => g.isCredit),
        },
    };
}
//# sourceMappingURL=trip-close.js.map